import React from "react";
import classNames from "classnames";
import {MdWarning} from "react-icons/md";
import {IoChevronDownOutline} from "react-icons/io5";

export const FilterPill = ({icon: Icon, value, placeholder, onClick, hasWarning = false}) => {
    const hasValue = !!value
    return (
        <button
            type="button"
            onClick={onClick}
            className={classNames(
                'w-full flex items-center gap-1.5 px-3 py-2 rounded-xl border text-sm transition-all',
                hasWarning
                    ? 'border-amber-300 bg-amber-50 text-amber-700'
                    : hasValue
                    ? 'border-indigo-300 bg-indigo-50 text-indigo-700'
                    : 'border-color-100 background text-color-300 hover:border-indigo-200 hover:bg-indigo-50'
            )}>
            {Icon && (
                <Icon
                    size={13}
                    className={classNames(
                        'flex-shrink-0',
                        hasWarning ? 'text-amber-500' : hasValue ? 'text-indigo-500' : 'text-color-400'
                    )}
                />
            )}
            <span className="font-medium flex-1 text-left min-w-0 truncate">
                {value || placeholder}
            </span>
            {hasWarning
                ? <MdWarning size={13} className="text-amber-500 flex-shrink-0 ml-0.5"/>
                : <IoChevronDownOutline size={11} className="text-color-300 flex-shrink-0 ml-0.5"/>
            }
        </button>
    )
}
